module.exports = __webpack_public_path__ + "ff3720bc95b04c0cd7dc867a4f3c7e77.svg";